import { render, staticRenderFns } from "./Enrollments24hr.vue?vue&type=template&id=5f98a9d9&scoped=true&"
import script from "./Enrollments24hr.vue?vue&type=script&lang=js&"
export * from "./Enrollments24hr.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pending-details.css?vue&type=style&index=0&lang=css&"
import style1 from "./Enrollments24hr.vue?vue&type=style&index=1&id=5f98a9d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f98a9d9",
  null
  
)

export default component.exports